import { MetricType } from './metric-type.enum';

export { default as dialCodes } from './dialCodes';

export * from './engine-tab.enum';

export enum permissions {
  VIEW_STATION = 'ViewStation',
  VIEW_STATION_ALERTS_RECORDS = 'ViewStationAlertsRecords',
  CREATE_CUSTOM_ALERT = 'CreateCustomAlert',
  UPDATE_CUSTOM_ALERT = 'UpdateCustomAlert',
  UPDATE_MANUFACTURER_ALERT = 'UpdateManufacturerAlert',
  UPDATE_ALERT_ACTIVE_FIELD = 'UpdateAlertActiveField',
  DELETE_CUSTOM_ALERT = 'DeleteCustomAlert',
  VIEW_STATION_ALERTS = 'ViewStationAlerts',
  UPDATE_ALERT_RECORD = 'UpdateAlertRecord',
  UPDATE_STATION_DETAILS = 'UpdateStationDetails',
  UPDATE_STATION_CONTROL = 'UpdateStationControl',
  UPDATE_DEVICE_MAINTENANCE = 'UpdateDeviceInMaintenance',
  CONTROL_DEVICE = 'ControlDevice',
  VIEW_STATION_USERS = 'ViewStationUsers',
  UPDATE_USER_NOTIFICATIONS_ENABLED = 'UpdateUserNotificationsEnabled',
  UPDATE_STATION_USER = 'UpdateStationUser',
  CREATE_STATION_USER = 'CreateStationUser',
  UPDATE_SELF_USER = 'UpdateSelfUser',
  VIEW_STATION_DRAFT = 'ViewStationDraft', // permission code 405
  VIEW_STATION_VALUE_DASHBOARD = 'ViewStationValueDashboard',
  VIEW_STATION_VALUE_DASHBOARD_STATION_RISK = 'ViewStationValueDashboardStationRisk',
  VIEW_STATION_REPORTS = 'ViewStationReports',
  VIEW_INTERNAL_SEVERITY_ALERT = 'ViewInternalSeverityAlert',
  EXTENDED_NOTIFICATION_ALERTS_SUBSCRIPTION = 'ExtendedNotificationAlertsSubscription', // permission code 514
  VIEW_STATION_VALUE_DASHBOARD_LEAKAGE = 'ViewStationValueDashboardLeakage', // permission code 702
  VIEW_STATION_VALUE_DASHBOARD_INSIGHTS = 'ViewStationValueDashboardInsights',
  VIEW_STATION_ENHANCED_METRICS = 'ViewStationEnhancedMetrics',
  VIEW_STATION_ENGINE = 'ViewStationEngine',
  UPDATE_STATION_ENGINE = 'UpdateStationEngine',
  VIEW_CUSTOM_GAUGES = 'ViewCustomGauges',
  VIEW_STATION_ENHANCED_COMMANDS_INFO = 'ViewStationEnhancedCommandsInfo',
  VIEW_ENHANCED_INVESTIGATION_DASHBOARD = 'ViewEnhancedInvestigationDashboard',
  VIEW_STATION_STAGE = 'ViewStationStage',
  UPDATE_STATION_STAGE = 'UpdateStationStage',
  ACCESS_INSTALLATION_VALIDATION_VIEW = 'AccessInstallationValidationView',
  COLLECT_INFO_AND_CREATE_STATION = 'CollectInfoAndCreateStation',
  INTERNAL_ACCESS = 'InternalAccess',
  UPDATE_DEVICE_IMAGES = 'UpdateDeviceImages',
  VIEW_STATION_STAGE_LIFECYCLE = 'ViewStationStageLifecycle',
  MANAGE_OPPORTUNITY_STATION_STAGE = 'ManageOpportunityStationStage',
  MANAGE_NEW_STATION_STAGE = 'ManageNewStationStage',
  MANAGE_DESIGN_STATION_STAGE = 'ManageDesignStationStage',
  MANAGE_ORDER_PLACEMENT_STATION_STAGE = 'ManageOrderPlacementStationStage',
  MANAGE_STAGING_STATION_STAGE = 'ManageStagingStationStage',
  MANAGE_INSTALLATION_STATION_STAGE = 'ManageInstallationStationStage',
  MANAGE_VALIDATION_STATION_STAGE = 'ManageValidationStationStage',
  MANAGE_BASELINE_STATION_STAGE = 'ManageBaselineStationStage',
  MANAGE_CONTROL_PREP_STATION_STAGE = 'ManageControlPrepStationStage',
  CAN_EDIT_MAP = 'UpdateStationPID',
  UPDATE_COMPRESSOR_ADDITIONAL_FIELDS = 'UpdateCompressorAdditionalFields',
  VIEW_STATION_SCORE = 'ViewStationScore',
  CREATE_STATION_VALUE_DASHBOARD_LEAKAGE = 'CreateStationValueDashboardLeakage',
  DELETE_STATION_VALUE_DASHBOARD_LEAKAGE = 'DeleteStationValueDashboardLeakage',
  VIEW_PERIODIC_REPORTS = 'ViewPeriodicReports', // permission code 911
  GENERATE_PERIODIC_REPORT = 'GeneratePeriodicReport', // permission code 912
  CREATE_STATION_VALUE_DASHBOARD_LEAKAGE_PERIOD = 'CreateStationValueDashboardLeakagePeriod', // permission code 913
  VIEW_STATION_VALUE_DASHBOARD_ALL_LEAKAGES = 'ViewStationValueDashboardAllLeakages', // permission code 914
  VIEW_SALES_ASSISTANT = 'SalesAssistantView',
}

export const metricsDetails = {
  [MetricType.WaterPressureIn]: {
    text: 'Water Pressure In',
    unit: 'bar',
  },
  [MetricType.WaterPressureOut]: {
    text: 'Water Pressure Out',
    unit: 'bar',
  },
  [MetricType.WaterPressureDelta]: {
    text: 'Water Pressure Delta',
    unit: 'bar',
  },
  [MetricType.PressureBar]: {
    text: 'Pressure',
    unit: 'bar',
  },
  [MetricType.FlowM3Min]: {
    text: 'Flow',
    unit: 'm^3/min',
  },
  [MetricType.WaterFlowM3Min]: {
    text: 'Water Flow',
    unit: 'm^3/min',
  },
  [MetricType.EstimatedFlowM3Min]: {
    text: 'est. Flow',
    unit: 'm^3/min',
  },
  [MetricType.PowerKw]: {
    text: 'Power',
    unit: 'kW',
  },
  [MetricType.EstimatedKw]: {
    text: 'est. Power',
    unit: 'kW',
  },
  [MetricType.TempCelsius]: {
    text: 'Temperature',
    unit: '°C',
  },
  [MetricType.DewpointTemperatureCelsius]: {
    text: 'Dew point temperature',
    unit: '°C',
  },
  [MetricType.InletWaterTemperatureCelsius]: {
    text: 'Inlet Water Temperature',
    unit: '°C',
  },
  [MetricType.OutletWaterTemperatureCelsius]: {
    text: 'Outlet Water Temperature',
    unit: '°C',
  },
  [MetricType.CurrentAmp]: {
    text: 'Current',
    unit: 'A',
  },
  [MetricType.OilTemperatureCelsius]: {
    text: 'Oil temperature',
    unit: '°C',
  },
  [MetricType.AirTemperatureCelsius]: {
    text: 'Air Temperature',
    unit: '°C',
  },
  [MetricType.InverterSpeedRPM]: {
    text: 'Inverter speed',
    unit: 'RPM',
  },
  [MetricType.RunHours]: {
    text: 'Run hours',
    unit: 'Hour',
  },
  [MetricType.LoadHours]: {
    text: 'Load hours',
    unit: 'Hour',
  },
  [MetricType.HumidityPercentage]: {
    text: 'Humidity',
    unit: '%',
  },
  [MetricType.ControlMode]: {
    text: 'Control mode',
    unit: '',
  },
  [MetricType.MinimumPressureBar]: {
    text: 'Minimum pressure',
    unit: 'bar',
  },
  [MetricType.MaximumPressureBar]: {
    text: 'Maximum pressure',
    unit: 'bar',
  },
  [MetricType.VSDPressureSetpointTargetBar]: {
    text: 'VSD Target Pressure',
    unit: 'bar',
  },
  [MetricType.NextServiceHours]: {
    text: 'Next service hours',
    unit: 'Hour',
  },
  [MetricType.NextServiceName]: {
    text: 'Next service name',
    unit: '',
  },
  [MetricType.Activity]: {
    text: 'Activity',
    unit: '',
  },
  [MetricType.SpecificPower]: {
    text: 'Specific Power',
    unit: 'kW/(m^3/min)',
  },
  [MetricType.EstimatedSpecificPower]: {
    text: 'est. Specific Power',
    unit: 'kW/(m^3/min)',
  },
  [MetricType.InletValveOpening]: {
    text: 'Inlet Valve Opening',
    unit: '%',
  },
  [MetricType.BypassValveOpening]: {
    text: 'Bypass Valve Opening',
    unit: '%',
  },
  [MetricType.ValveMinSetpoint]: {
    text: 'Minimum Valve Set Point',
    unit: '%',
  },
  [MetricType.ValveMaxSetpoint]: {
    text: 'Maximum Valve Set Point',
    unit: '%',
  },
  [MetricType.ValveCurrentPosition]: {
    text: 'Current Valve Position',
    unit: '%',
  },
  [MetricType.SpillValveHpLowLimitSetpointBar]: {
    text: 'Spill Valve HP Low Limit Setpoint',
    unit: 'bar',
  },
  [MetricType.SpillValveHpPressureBar]: {
    text: 'Spill Valve High Pressure',
    unit: 'bar',
  },
  [MetricType.SpillValveLpTargetSetpointBar]: {
    text: 'Spill Valve LP Target Setpoint',
    unit: 'bar',
  },
  [MetricType.SpillValveLpPressureBar]: {
    text: 'Spill Valve Low Pressure',
    unit: 'bar',
  },
  [MetricType.CentrifugalTargetSetpoint]: {
    text: 'Centrifugal Target Setpoint',
    unit: 'bar',
  },
  [MetricType.EstimatedInverterSpeedRPM]: {
    text: 'est. Inverter Speed',
    unit: 'rpm',
  },
  [MetricType.PoweredOn]: {
    text: 'Powered On',
    unit: '',
  },
  [MetricType.BypassValveUnloadPointPercent]: {
    text: 'Auto Dual Unload Point',
    unit: '%',
    fractionDigits: 0,
  },
  [MetricType.TargetPressureReloadPercent]: {
    text: 'Auto Dual Reload Point',
    unit: '%',
    fractionDigits: 0,
  },
  [MetricType.AutoHotStartBar]: {
    text: 'Auto Hot Start Pressure',
    unit: 'bar',
  },
  [MetricType.MotorWindingTemperatureCelsius]: {
    text: 'Motor Winding Temperature',
    unit: '°C',
  },
  [MetricType.AirDischargeTemperatureCelsius]: {
    text: 'Air Discharge Temperature',
    unit: '°C',
  },
  [MetricType.FirstStageTemperatureCelsius]: {
    text: 'Stage 1 Temperature',
    unit: '°C',
  },
  [MetricType.SecondStageTemperatureCelsius]: {
    text: 'Stage 2 Temperature',
    unit: '°C',
  },
  [MetricType.ThirdStageTemperatureCelsius]: {
    text: 'Stage 3 Temperature',
    unit: '°C',
  },
  [MetricType.FourthStageTemperatureCelsius]: {
    text: 'Stage 4 Temperature',
    unit: '°C',
  },
  [MetricType.SurgeCount]: {
    text: 'Surge Count',
    unit: '',
  },
  [MetricType.VibrationsLimitMicrons]: {
    text: 'Vibration Limit',
    unit: 'microns',
  },
  [MetricType.FirstStageVibrationsMicrons]: {
    text: 'Stage 1 Vibration',
    unit: 'microns',
  },
  [MetricType.SecondStageVibrationsMicrons]: {
    text: 'Stage 2 Vibration',
    unit: 'microns',
  },
  [MetricType.ThirdStageVibrationsMicrons]: {
    text: 'Stage 3 Vibration',
    unit: 'microns',
  },
  [MetricType.FourthStageVibrationsMicrons]: {
    text: 'Stage 4 Vibration',
    unit: 'microns',
  },
  [MetricType.VoltageVolt]: {
    text: 'Voltage',
    unit: 'V',
  },
  [MetricType.PowerFactor]: {
    text: 'Power Factor',
    unit: '',
  },
  [MetricType.IntercoolerPressureBar]: {
    text: 'Intercooler pressure',
    unit: 'bar',
  },
  [MetricType.InteriorAmbientTemperatureCelsius]: {
    text: 'Interior Ambient Temperature',
    unit: '°C',
  },
  [MetricType.ExteriorAmbientTemperatureCelsius]: {
    text: 'Exterior Ambient Temperature',
    unit: '°C',
  },
  [MetricType.BlowerSpeedRPM]: {
    text: 'Blower Speed',
    unit: 'RPM',
  },
  [MetricType.TargetBlowerSpeedRPM]: {
    text: 'Blower Target Speed',
    unit: 'RPM',
  },
  [MetricType.FrequencyHz]: {
    text: 'Frequency',
    unit: 'Hz',
  },
  [MetricType.HorsePower]: {
    text: 'Horse Power',
    unit: 'hp',
  },
  [MetricType.WaterTemperatureCelsius]: {
    text: 'Water Temperature',
    unit: '°C',
  },
  [MetricType.WorkingHours]: {
    text: 'Working Hours',
    unit: 'h',
  },
  [MetricType.DissolvedOxygenPPM]: {
    text: 'Dissolved Oxygen',
    unit: 'ppm',
  },
  [MetricType.InfluentFlowM3Hour]: {
    text: 'Influent flow',
    unit: 'm^3/hour',
  },
  [MetricType.PH]: {
    text: 'pH',
    unit: 'pH',
  },
  [MetricType.AmmoniaAmmoniumPPM]: {
    text: 'Ammonia ammonium',
    unit: 'ppm',
  },
  [MetricType.OxidationReductionPotentialMV]: {
    text: 'Oxidation reduction potential',
    unit: 'mv',
  },
  [MetricType.NitritePPM]: {
    text: 'Nitrite no 2',
    unit: 'ppm',
  },
  [MetricType.NitratePPM]: {
    text: 'Nitrate no 3',
    unit: 'ppm',
  },
  [MetricType.MinInverterSpeedRPM]: {
    text: 'Min Inverter Speed',
    unit: 'RPM',
  },
  [MetricType.MaxInverterSpeedRPM]: {
    text: 'Max Inverter Speed',
    unit: 'RPM',
  },
  [MetricType.PerformanceLoss]: {
    text: 'Performance Loss',
    unit: '%',
  },
  [MetricType.VibrationGearbox]: {
    text: 'Vibration Gearbox',
    unit: 'G',
  },
  [MetricType.RotorSpeedRPM]: {
    text: 'Rotor Speed',
    unit: 'RPM',
  },
  [MetricType.SuctionPressure]: {
    text: 'Suction Pressure',
    unit: 'bar',
  },
  [MetricType.OperatingHours]: {
    text: 'Operating Hours',
    unit: 'h',
  },
  [MetricType.DischargeTemperatureCelsius]: {
    text: 'Discharge Temperature',
    unit: '°C',
  },
  [MetricType.TargetPressureBand1Bar]: {
    text: 'Target Pressure Band 1',
    unit: 'bar',
  },
  [MetricType.TargetPressureBand2Bar]: {
    text: 'Target Pressure Band 2',
    unit: 'bar',
  },
  [MetricType.AirendInletCoolantTempCelsius]: {
    text: 'Airend Inlet Coolant Temperature',
    unit: '°C',
  },
  [MetricType.AirendOutletCoolantTempCelsius]: {
    text: 'Airend Outlet Coolant Temperature',
    unit: '°C',
  },
  [MetricType.InletAirTemperatureCelsius]: {
    text: 'Inlet Air Temperature',
    unit: '°C',
  },
  [MetricType.AirendTemperatureCelsius]: {
    text: 'Airend Temperature',
    unit: '°C',
  },
  [MetricType.TempCelsiusTSE]: {
    text: 'Temperature TSE',
    unit: '°C',
  },
  [MetricType.MinimumPressureBand1Bar]: {
    text: 'Minimum Pressure Band 1',
    unit: 'bar',
  },
  [MetricType.MaximumPressureBand1Bar]: {
    text: 'Maximum Pressure Band 1',
    unit: 'bar',
  },
  [MetricType.MinimumPressureBand2Bar]: {
    text: 'Minimum Pressure Band 2',
    unit: 'bar',
  },
  [MetricType.MaximumPressureBand2Bar]: {
    text: 'Maximum Pressure Band 2',
    unit: 'bar',
  },
  [MetricType.RemoteMode]: {
    text: 'Remote Mode',
    unit: '',
  },
  [MetricType.IsMinLoaded]: {
    text: 'Is Min Loaded',
    unit: '',
  },
  [MetricType.IsMaxLoaded]: {
    text: 'Is Max Loaded',
    unit: '',
  },
  [MetricType.IsFullLoaded]: {
    text: 'Is Full Loaded',
    unit: '',
  },
  [MetricType.IsCheckValveClosed]: {
    text: 'Is Check Valve Closed',
    unit: '',
  },
  [MetricType.GeneralShutdown]: {
    text: 'General Shutdown',
    unit: '',
  },
  [MetricType.FiveLoopPressureOffset]: {
    text: 'Five Loop Pressure Offset',
    unit: 'bar',
  },
  [MetricType.UnloadToOffSeconds]: {
    text: 'Unload To Off Seconds',
    unit: 's',
  },
  [MetricType.LocalStationControl]: {
    text: 'Local Station Control',
    unit: '',
  },
  [MetricType.StationOnOff]: {
    text: 'Station On/Off',
    unit: '',
  },
  [MetricType.PressureBand]: {
    text: 'Pressure Band',
    unit: '',
  },
  [MetricType.AutoStop]: {
    text: 'Auto Stop',
    unit: '',
  },
  [MetricType.ImmediateStop]: {
    text: 'Immediate Stop',
    unit: '',
  },
  [MetricType.Modulation]: {
    text: 'Modulation',
    unit: '',
  },
  [MetricType.OperationMode]: {
    text: 'Operation Mode',
    unit: '',
  },
  [MetricType.ExtendedActivity]: {
    text: 'Extended Activity',
    unit: '',
  },
  [MetricType.RunMinutes]: {
    text: 'Run minutes',
    unit: 'min',
  },
  [MetricType.PipeDiameter]: {
    text: 'Pipe diameter',
    unit: 'mm',
  },
  [MetricType.Last24HrsCycles]: {
    text: 'Last 24 hrs cycles',
    unit: '',
  },
  [MetricType.Last24HrsLoadAvg]: {
    text: 'Last 24 hrs load avg',
    unit: '%',
  },
  [MetricType.Last24HrsUnloadAvg]: {
    text: 'Last 24 hrs unload avg',
    unit: '%',
  },
  [MetricType.MaxMinDeltaPressureBar]: {
    text: 'Max Min Delta Pressure',
    unit: 'bar',
  },
  [MetricType.ValveActivity]: {
    text: 'Valve Activity',
    unit: '',
  },
  [MetricType.ValveSetpoint]: {
    text: 'Valve Setpoint',
    unit: '%',
  },
  [MetricType.ValveAction]: {
    text: 'Valve Action',
    unit: '',
  },
  [MetricType.ValveDefaultState]: {
    text: 'Valve Default State',
    unit: '',
  },
  [MetricType.DryerFilterServiceHours]: {
    text: 'Dryer Filter Service Hours',
    unit: 'Hour',
  },
  [MetricType.DryerDesiccantServiceHours]: {
    text: 'Dryer Desiccant Service Hours',
    unit: 'Hour',
  },
  [MetricType.DryerValveServiceHours]: {
    text: 'Dryer Valve Service Hours',
    unit: 'Hour',
  },
  [MetricType.DryerLeftTowerActivity]: {
    text: 'Dryer Left Tower Activity',
    unit: '',
  },
  [MetricType.DryerRightTowerActivity]: {
    text: 'Dryer Right Tower Activity',
    unit: '',
  },
  [MetricType.DryerBlowerActivity]: {
    text: 'Dryer Blower Activity',
    unit: '',
  },
  [MetricType.DryerHeaterActivity]: {
    text: 'Dryer Heater Activity',
    unit: '',
  },
  [MetricType.DryerTemperatureSetpointCelsius]: {
    text: 'Dryer Temperature Setpoint',
    unit: '°C',
  },
  [MetricType.DryerOperationMode]: {
    text: 'Dryer Operation Mode',
    unit: '',
  },
  [MetricType.DryerExtendedActivity]: {
    text: 'Dryer Extended Activity',
    unit: '',
  },
  [MetricType.MinimumDissolvedOxygenPPM]: {
    text: 'Minimum Dissolved Oxygen',
    unit: 'ppm',
  },
  [MetricType.MaximumDissolvedOxygenPPM]: {
    text: 'Maximum Dissolved Oxygen',
    unit: 'ppm',
  },
  [MetricType.TargetDissolvedOxygenPPM]: {
    text: 'Target Dissolved Oxygen',
    unit: 'ppm',
  },
  [MetricType.MinimumBlowerSpeedRPM]: {
    text: 'Min Blower Speed',
    unit: 'RPM',
  },
  [MetricType.MaximumBlowerSpeedRPM]: {
    text: 'Max Blower Speed',
    unit: 'RPM',
  },
  [MetricType.FlowM3HourPump]: {
    text: 'Flow',
    unit: 'm^3/hour',
  },
};
